/**
 * CONODATA
 * Copyright (c) 2025 Cognoware Cia. Ltda.
 * Todos los derechos reservados.
 * <p>
 * Este archivo forma parte del Sistema de Votación Electrónica de
 * Cognoware Cia. Ltda, desarrollado conforme a los requerimientos y
 * normativas establecidos.
 */
import {
    LOADING_CP_IMPORT,
    SUCCESS_CP_IMPORT,
    ERROR_CP_IMPORT,
    LOADING_CP_IMPORT_SUMMARY,
    SUCCESS_CP_IMPORT_SUMMARY,
    ERROR_CP_IMPORT_SUMMARY,
    LOADING_CP_IMPORT_ERRORS,
    SUCCESS_CP_IMPORT_ERRORS,
    ERROR_CP_IMPORT_ERRORS,
    LOADING_CP_ADMIN_LIST,
    SUCCESS_CP_ADMIN_LIST,
    ERROR_CP_ADMIN_LIST,
    LOADING_CP_EDIT,
    SUCCESS_CP_EDIT,
    ERROR_CP_EDIT,
    LOADING_CP_DEACTIVATE,
    SUCCESS_CP_DEACTIVATE,
    ERROR_CP_DEACTIVATE,
    LOADING_CP_ACTIVATE,
    SUCCESS_CP_ACTIVATE,
    ERROR_CP_ACTIVATE,
    RESET_CP_STATE,
    RESET_CP_OPERATION
} from '../../actionsType/comportamientoPago/comportamientoPagoActionType'

/**
 * Administra el estado Redux de importación y administración de comportamiento de pago.
 *
 * Expone banderas de carga, resultados exitosos y errores para cada operación
 * del módulo, además de acciones de reseteo.
 *
 * @author DSISALIMA
 * @version 1.0.0
 * @since 2026-02-18
 */
const INITIAL_STATE = {
    // Import
    loading_cpImport: false,
    success_cpImport: null,
    error_cpImport: null,

    // Import Summary
    loading_cpImportSummary: false,
    success_cpImportSummary: null,
    error_cpImportSummary: null,

    // Import Errors
    loading_cpImportErrors: false,
    success_cpImportErrors: null,
    error_cpImportErrors: null,

    // Admin List
    loading_cpAdminList: false,
    success_cpAdminList: null,
    error_cpAdminList: null,

    // Edit
    loading_cpEdit: false,
    success_cpEdit: null,
    error_cpEdit: null,

    // Deactivate
    loading_cpDeactivate: false,
    success_cpDeactivate: null,
    error_cpDeactivate: null,

    // Activate
    loading_cpActivate: false,
    success_cpActivate: null,
    error_cpActivate: null
}

/**
 * Reducer principal del módulo Comportamiento de Pago.
 *
 * @param {object} state estado actual del módulo
 * @param {object} action acción Redux despachada
 * @returns {object} nuevo estado inmutable
 */
export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case LOADING_CP_IMPORT:
            return { ...state, loading_cpImport: true, error_cpImport: null, success_cpImport: null }
        case SUCCESS_CP_IMPORT:
            return { ...state, loading_cpImport: false, success_cpImport: action.payload, error_cpImport: null }
        case ERROR_CP_IMPORT:
            return { ...state, loading_cpImport: false, error_cpImport: action.payload, success_cpImport: null }

        case LOADING_CP_IMPORT_SUMMARY:
            return { ...state, loading_cpImportSummary: true, error_cpImportSummary: null, success_cpImportSummary: null }
        case SUCCESS_CP_IMPORT_SUMMARY:
            return { ...state, loading_cpImportSummary: false, success_cpImportSummary: action.payload, error_cpImportSummary: null }
        case ERROR_CP_IMPORT_SUMMARY:
            return { ...state, loading_cpImportSummary: false, error_cpImportSummary: action.payload, success_cpImportSummary: null }

        case LOADING_CP_IMPORT_ERRORS:
            return { ...state, loading_cpImportErrors: true, error_cpImportErrors: null }
        case SUCCESS_CP_IMPORT_ERRORS:
            return { ...state, loading_cpImportErrors: false, success_cpImportErrors: action.payload, error_cpImportErrors: null }
        case ERROR_CP_IMPORT_ERRORS:
            return { ...state, loading_cpImportErrors: false, error_cpImportErrors: action.payload, success_cpImportErrors: null }

        case LOADING_CP_ADMIN_LIST:
            return { ...state, loading_cpAdminList: true, error_cpAdminList: null }
        case SUCCESS_CP_ADMIN_LIST:
            return { ...state, loading_cpAdminList: false, success_cpAdminList: action.payload, error_cpAdminList: null }
        case ERROR_CP_ADMIN_LIST:
            return { ...state, loading_cpAdminList: false, error_cpAdminList: action.payload, success_cpAdminList: null }

        case LOADING_CP_EDIT:
            return { ...state, loading_cpEdit: true, error_cpEdit: null, success_cpEdit: null }
        case SUCCESS_CP_EDIT:
            return { ...state, loading_cpEdit: false, success_cpEdit: action.payload, error_cpEdit: null }
        case ERROR_CP_EDIT:
            return { ...state, loading_cpEdit: false, error_cpEdit: action.payload, success_cpEdit: null }

        case LOADING_CP_DEACTIVATE:
            return { ...state, loading_cpDeactivate: true, error_cpDeactivate: null, success_cpDeactivate: null }
        case SUCCESS_CP_DEACTIVATE:
            return { ...state, loading_cpDeactivate: false, success_cpDeactivate: action.payload, error_cpDeactivate: null }
        case ERROR_CP_DEACTIVATE:
            return { ...state, loading_cpDeactivate: false, error_cpDeactivate: action.payload, success_cpDeactivate: null }

        case LOADING_CP_ACTIVATE:
            return { ...state, loading_cpActivate: true, error_cpActivate: null, success_cpActivate: null }
        case SUCCESS_CP_ACTIVATE:
            return { ...state, loading_cpActivate: false, success_cpActivate: action.payload, error_cpActivate: null }
        case ERROR_CP_ACTIVATE:
            return { ...state, loading_cpActivate: false, error_cpActivate: action.payload, success_cpActivate: null }

        case RESET_CP_STATE:
            return { ...INITIAL_STATE }

        case RESET_CP_OPERATION:
            return {
                ...state,
                loading_cpEdit: false,
                success_cpEdit: null,
                error_cpEdit: null,
                loading_cpDeactivate: false,
                success_cpDeactivate: null,
                error_cpDeactivate: null,
                loading_cpActivate: false,
                success_cpActivate: null,
                error_cpActivate: null
            }

        default:
            return state
    }
}
